import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Cómo recibo el libro?',
    answer: 'Inmediatamente después del pago recibirás un enlace de descarga.'
  }, {
    question: '¿Necesito experiencia en repostería?',
    answer: 'No, las recetas están pensadas para cualquier nivel.'
  }, {
    question: '¿Los ingredientes son fáciles de conseguir?',
    answer: 'Sí, usamos ingredientes comunes que encontrás en cualquier supermercado.'
  }, {
    question: '¿Puedo verlo en mi celular?',
    answer: 'Sí, el libro es en formato PDF compatible con cualquier dispositivo.'
  }, {
    question: '¿Qué pasa si no me gusta?',
    answer: 'Tenés 45 días para pedir tu reembolso completo, sin preguntas.'
  }, {
    question: '¿El pago es seguro?',
    answer: 'Sí, utilizamos plataformas de pago certificadas y seguras.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-[#FFF5EB] text-[#3D2B1F] px-4" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-44">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-[#9C8578]" data-id="element-45">
            Todo lo que necesitás saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-[#3D2B1F]/10 rounded-2xl overflow-hidden shadow-sm" data-id="element-47">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-48">
                <span className="text-xl font-bold text-[#4A3728] pr-8" data-id="element-49">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#C67B30] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>

              <AnimatePresence data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52">
                    <div className="p-6 pt-0 text-[#9C8578] text-lg border-t border-[#3D2B1F]/5 mt-2" data-id="element-53">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}